import api from "./client.ts";
import { useEffect, useState, createContext, useContext } from "react";

//athentication services
export const login = async (credentials) => {
  const { data } = await api.post("/user/login", credentials);
  localStorage.setItem("token", data.token);
  return data;
};

//logout user
export const logout = async () => {
  const { data } = await api.get("/user/logout");
  localStorage.removeItem("token");
  return data;
};

// Auth context and provider
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token") || null);

  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  // Sync token to localStorage
  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (token && token !== storedToken) {
      localStorage.setItem("token", token);
    } else if (!token && storedToken) {
      localStorage.removeItem("token");
    }
  }, [token]);

  // Sync user to localStorage
  useEffect(() => {
    if (user) localStorage.setItem("user", JSON.stringify(user));
    else localStorage.removeItem("user");
  }, [user]);

  const login = (tokenValue, userData) => {
    setToken(tokenValue);
    setUser(userData);
  };

  const logout = () => {
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
